module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAABHNCSVQICAgIfAhkiAAAAGtJREFUKFNjZCAT/P//fwJQ6wVGRsYFyEYwkmkeA9BAA6DeA0BcgGwo2QaCHILNUIoMxGYoI9CW/+R6G4s+R2q4UABo8H4gvggMywSKDAR6DsUwkIvJNhCbYZQaCE5/IG9SKx0KAA37gB4xAN5AL0gO4WSXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiantou.png
// module id = JSah
// module chunks = 1